// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { logoStyles } from "@guestsupply/Overrides/Widgets/Basic/Logo";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css`
        max-width: ${({ isCheckoutPage }: any) => (isCheckoutPage ? "180px" : "260px")};
        height: ${({ isCheckoutPage }: any) => (isCheckoutPage ? "34px" : "48px")};
        width: ${({ isCheckoutPage }: any) => (isCheckoutPage ? "180px" : "260px")};
        display: flex;
        align-items: center;
        ${xScreen("lte", "md")} {
            max-width: 164px;
            width: 164px;
            height: 36px;
        }
        ${xScreen("lte", 340)} {
            max-width: 138px;
            width: 138px;
            height: 32px;
        }

        .home-page-link {
            width: 100%;
            span {
                display: flex;
                width: 100%;
            }
        }
    `,
};

logoStyles.img = {
    css: css`
        height: auto;
        max-width: 100%;
        max-height: 100%;
    `,
};

logoStyles.hiddenStyles = {
    css: css`
        display: flex;
    `,
};
